import type React from "react";
import { Box, Avatar, Typography, Button } from "@mui/material";
import { getRandomColor } from "./utils/GetRandomColor";
import { Comment } from "./types/comments";

interface CommentCardProps {
  comment: Comment;
}

const CommentCard: React.FC<CommentCardProps> = ({ comment }) => {
  return (
    <Box
      sx={{
        display: "flex",
        gap: 1.5,
        p: 1.5,
        backgroundColor: "#fafafa",
        borderRadius: "8px",
        border: "1px solid #eeeeee",
      }}
    >
      <Avatar
        sx={{
          backgroundColor: getRandomColor(comment.author),
          width: 36,
          height: 36,
          fontSize: "14px",
        }}
      >
        {comment.author.charAt(0).toUpperCase()}
      </Avatar>
      <Box sx={{ flex: 1 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 0.5,
          }}
        >
          <Typography
            variant="subtitle2"
            sx={{ fontWeight: 600, color: "#212121", fontSize: "13px" }}
          >
            {comment.author}
          </Typography>
          <Typography
            variant="caption"
            sx={{ color: "#9e9e9e", fontSize: "11px" }}
          >
            {comment.date}
          </Typography>
        </Box>
        <Typography
          variant="body2"
          sx={{ color: "#424242", lineHeight: 1.5, mb: 1, fontSize: "13px" }}
        >
          {comment.text}
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            size="small"
            variant="outlined"
            sx={{
              textTransform: "none",
              fontSize: "11px",
              padding: "2px 8px",
              borderColor: "#e0e0e0",
              color: "#757575",
              "&:hover": {
                borderColor: "#bdbdbd",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Disapprove
          </Button>
          <Button
            size="small"
            variant="outlined"
            sx={{
              textTransform: "none",
              fontSize: "11px",
              padding: "2px 8px",
              borderColor: "#e0e0e0",
              color: "#757575",
              "&:hover": {
                borderColor: "#bdbdbd",
                backgroundColor: "#f5f5f5",
              },
            }}
          >
            Delete
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default CommentCard;
